import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {
  public currentMessage: BehaviorSubject<any>;
  public currentState: BehaviorSubject<any>;

  //global service
  private Obj = {};
  //etat de l'objet données
  defaultObject: any = null;
  //etat du loading
  defaultState: any = false;

  constructor() { 
    //init data
    this.currentMessage = new BehaviorSubject(this.defaultObject);
    this.currentState = new BehaviorSubject(this.defaultState);
  }

  changeMessage(prop: any, data: any) {
    this.Obj[prop] = data;
    this.currentMessage.next(this.Obj);
  }

  changeState(state: boolean) {
    this.currentState.next(state);
  }
}